import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, FormControlLabel, TextField, MenuItem } from "@material-ui/core";
import Checkbox from "../../Common/CustomCheckbox";
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from './../../../utils/guid';
import withSaveButton from './../../HOC/withSaveButton';
import { compose } from "recompose";

const useStyles = theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 500,
        margin: theme.spacing(1)
    },
    checksContainer: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        marginTop: theme.spacing(1)
    },
    inputsContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
    },
    checksColumn: {
        display: "flex",
        flexDirection: "column",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    checkbox: {
        color: "grey"
    },
    select: {
        minWidth: 170
    },

});

const RentChecklist = props => {
    const { classes, title, data, onChange } = props;
    const [updatedData, setUpdatedData] = useState(data);

    useEffect(() => {
        setUpdatedData(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(updatedData);
        onChange && onChange(updatedData);
    }, [updatedData]);

    const handleOthersInputChange = (e) => {
        e.persist();
        setUpdatedData(state => ({ ...state, inne: e.target.value }));
    };

    const printOptions = array => {
        if (notArrayOrEmpty(array))
            return;
        return array.map(option => (
            <MenuItem
                key={guid()}
                value={option}
            >
                {option}
            </MenuItem>
        ));
    };

    return (
        <div className={classes.container}>
            <Typography variant="subtitle1">
                {title}
            </Typography>
            <div className={classes.checksContainer}>
                <div className={classes.checksColumn}>
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.cleanOutside}
                        name="czysty_zewnatrz"
                        checked={updatedData.czysty_zewnatrz}
                        onChange={(e) => setUpdatedData(state => ({ ...state, czysty_zewnatrz: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.cleanInside}
                        name="czysty_wewnatrz"
                        checked={updatedData.czysty_wewnatrz}
                        onChange={(e) => setUpdatedData(state => ({ ...state, czysty_wewnatrz: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.fireExtinguisher}
                        name="gasnica"
                        checked={updatedData.gasnica}
                        onChange={(e) => setUpdatedData(state => ({ ...state, gasnica: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.tools}
                        name="narzedzia"
                        checked={updatedData.narzedzia}
                        onChange={(e) => setUpdatedData(state => ({ ...state, narzedzia: e.target.checked }))}
                    />
                </div>
                <div className={classes.checksColumn}>
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.warningTriangle}
                        name="trojkat"
                        checked={updatedData.trojkat}
                        onChange={(e) => setUpdatedData(state => ({ ...state, trojkat: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.medkit}
                        name="apteczka"
                        checked={updatedData.apteczka}
                        onChange={(e) => setUpdatedData(state => ({ ...state, apteczka: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.documents}
                        name="dokumenty"
                        checked={updatedData.dokumenty}
                        onChange={(e) => setUpdatedData(state => ({ ...state, dokumenty: e.target.checked }))}
                    />
                    <FormControlLabel
                        control={<Checkbox className={classes.checkbox} />}
                        label={t.radio}
                        name="radio"
                        checked={updatedData.radio}
                        onChange={(e) => setUpdatedData(state => ({ ...state, radio: e.target.checked }))}
                    />
                </div>
            </div>
            <div className={classes.inputsContainer}>
                <TextField
                    select
                    label={t.repairEquipment}
                    className={classes.select}
                    defaultValue=""
                    name="akcesoria"
                    value={updatedData.akcesoria}
                    onChange={(e) => setUpdatedData(state => ({ ...state, akcesoria: e.target.value }))}
                >
                    <MenuItem value=""><em>{t.pick}</em></MenuItem>
                    {printOptions(updatedData.akcesoria_opcje)}
                </TextField>
                <TextField
                    label={t.others}
                    fullWidth
                    name="inne"
                    value={updatedData.inne}
                    onChange={handleOthersInputChange}
                />
            </div>
        </div>
    );
};

RentChecklist.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    data: PropTypes.object,
    onChange: PropTypes.func,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withSaveButton
)(RentChecklist);
